import React from 'react';
import { Grid } from '@mui/material';
import { moneyFormat } from 'helpers/moneyFormat';
import { ProcedurePackage } from 'types/procedure';
import { RecordColumn, RecordList } from 'components/record-shell/RecordList';

interface ProcedurePackagesListProps {
  packages: ProcedurePackage[];
  handleDeletePackage(pkg: ProcedurePackage, index: number): void;
  handleEditPackage(pkg: ProcedurePackage, index: number): void;
}

const columns: RecordColumn[] = [
  { id: 'name', label: 'Pacote' },
  { id: 'cost', label: 'Custo', align: 'right', width: '110px' },
  { id: 'min', label: 'Mínimo', shortLabel: 'Mín', align: 'right', width: '110px' },
  { id: 'max', label: 'Máximo', shortLabel: 'Máx', align: 'right', width: '110px' },
];

const ProcedurePackagesList: React.FC<ProcedurePackagesListProps> = ({
  packages,
  handleDeletePackage,
  handleEditPackage,
}) => (
  <Grid size={12}>
    <RecordList
      columns={columns}
      rows={packages.map((item, index) => ({
        key: item.id || index,
        values: {
          name: item.package?.name || 'Pacote',
          cost: moneyFormat(item.package?.cost_price),
          min: moneyFormat(item.package?.sale_price_min),
          max: moneyFormat(item.package?.sale_price_max),
        },
      }))}
      onEdit={index => handleEditPackage(packages[index], index)}
      onDelete={index => handleDeletePackage(packages[index], index)}
    />
  </Grid>
);

export default ProcedurePackagesList;
